<template>
  <div class="form-group" :attribute="field.attribute">
    <slot name="field" />
    <slot name="errors">
      <div
        v-if="hasError"
        class="invalid-feedback d-block"
        v-html="errorMessages"
      />
    </slot>
    <small v-if="showHelpText" class="form-text text-muted">
      {{ field.helpText }}
    </small>
  </div>
</template>

<script>
import { FieldLayoutMixin } from "stylemix-base";

export default {
  name: "NolabelLayout",
  mixins: [FieldLayoutMixin],
};
</script>
